import {
  FETCH_GLOBAL_CONFIG,
  LOAD_GLOBAL_CONFIG
} from '../Actions/Global'

const initialState = {
  enableFeatureSmsAlerts: false
}

/**
 * GlobalConfigReducer
 * @desc Global Config State handler for global config data
 * @param {Object} state
 * @param {action} action
 * @return {Object} updated content state
 */
export default function GlobalConfigReducer (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }

  const globalConfig = action.data && action.data.getGlobalConfig

  switch (action.type) {
    case FETCH_GLOBAL_CONFIG:
      return Object.assign({}, state, { enableFeatureSmsAlerts: false })
    case LOAD_GLOBAL_CONFIG:
      return Object.assign({}, state, { enableFeatureSmsAlerts: globalConfig.enableFeatureSmsAlerts })
    default:
      return state
  }
}
